// extracted by mini-css-extract-plugin
export default {"card":"card--a_Gh7"};